'use client';

import { useId } from 'react';
import { Gradient } from '../gradient';

export const Altruism = () => {
  const gradientId = useId();

  return (
    <>
      <Gradient gradientId={gradientId} />
      <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3451_22485)">
          <path
            d="M143.058 174.876C136.437 163.535 133.327 150.485 134.122 137.377C134.917 124.268 139.582 111.69 147.526 101.232C155.47 90.7749 166.337 82.9082 178.752 78.6271C191.168 74.346 204.574 73.8427 217.275 77.1809C229.976 80.5192 241.402 87.549 250.108 97.3813C258.814 107.214 264.409 119.407 266.185 132.419C267.96 145.431 265.838 158.677 260.085 170.483C254.332 182.289 245.207 192.123 233.865 198.743C226.336 203.141 218.015 206.013 209.376 207.193C200.737 208.374 191.949 207.841 183.516 205.625C175.083 203.409 167.17 199.552 160.228 194.276C153.286 189 147.452 182.408 143.058 174.876Z"
            fill={`url(#${gradientId})`}
          />
          <path
            d="M235.238 139.691C231.379 161.957 211.943 180.25 211.943 180.25C211.943 180.25 185.647 175.534 170.27 158.985C157.465 145.208 157.351 126.201 168.841 118.626C185.333 107.765 199.367 137.948 199.367 137.948C199.367 137.948 194.651 105.021 214.401 105.107C228.178 105.164 238.582 121.141 235.238 139.691Z"
            fill="white"
          />
          <path
            d="M224.152 260.124C231.564 249.428 235.638 241.424 240.872 234.677C247.335 226.358 249.443 222.478 247.897 221.36C246.351 220.241 246.597 220.381 232.688 233.803C232.688 233.803 252.393 214.439 244.806 215.312C241.469 215.697 224.925 231.601 224.925 231.601C239.397 220.031 242.979 213.39 241.118 211.328C238.413 208.287 218.497 227.791 218.497 227.791C218.497 227.791 233.987 213.215 236.06 209.825C238.132 206.434 233.32 207.273 229.667 209.056C226.014 210.838 203.534 226.044 196.93 230.028C196.414 230.435 195.814 230.724 195.174 230.876C194.534 231.029 193.868 231.04 193.223 230.911C192.578 230.781 191.969 230.513 191.438 230.125C190.907 229.737 190.468 229.239 190.151 228.665C186.182 218.179 177.506 212.201 174.38 211.677C173.68 211.68 172.998 211.89 172.42 212.281C171.842 212.672 171.394 213.226 171.133 213.871C170.873 214.517 170.812 215.225 170.959 215.905C171.105 216.585 171.453 217.207 171.956 217.689C174.365 220.616 176.351 223.863 177.857 227.337C179.196 230.047 180.052 232.969 180.386 235.971C180.772 239.466 180.983 242.437 181.053 244.954L171.043 300.532L206.168 325L224.152 260.124Z"
            fill="#B78876"
          />
          <path
            d="M224.629 242.5C231.721 237.115 238.03 230.807 243.379 223.75C236.331 229.184 230.029 235.486 224.629 242.5Z"
            fill="#AA6550"
          />
          <path
            d="M218.452 237.5C222.52 235.03 226.277 232.098 229.644 228.766C233.369 225.829 236.722 222.467 239.631 218.75C231.778 224.11 224.639 230.409 218.381 237.5H218.452Z"
            fill="#AA6550"
          />
          <path
            d="M213.383 232.5C220.316 227.558 226.619 221.675 232.133 215C228.534 217.245 225.227 219.987 222.299 223.155C218.942 225.821 215.942 228.966 213.383 232.5Z"
            fill="#AA6550"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3451_22485"
            x="128"
            y="71"
            width="144.795"
            height="262"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22485"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22485"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
